import util from '../util'

let controller = 'EnvioCM'
export default Object.assign({}, util.GetCrud(controller, ['getall']))
